module.exports = __webpack_public_path__ + "static/img/other-mobile.f3360602.png";